import { atom } from "jotai";

/**
 * Indicates whether the FFWD ads are enabled or not.
 * When they are enabled, we may still decide to show or not show the markers.
 */
export const ffwdAdsEnabledAtom = atom<boolean>(false);
